/* jshint esversion: 6 */

/***********************************************************************
 BaseProfileController
 ************************************************************************
 Base controller class for user dependend data.
 ***********************************************************************/
import {SequenceProfileData} from "common/datapersistence/SequenceProfileData";

export function LearningData() {

    let username = "";
    const learningDataMap = new Map();

    function getLearningData(scoId) {

        if (scoId && learningDataMap.has(scoId)) {
            return learningDataMap.get(scoId);
        }

        return null;
    }

    function setLearningData(scoId, data) {

        if (!scoId) {
            return;
        }

        if (learningDataMap.has(scoId)) {
            learningDataMap.get(scoId).setData(data);
            return;
        }

        learningDataMap.set(scoId, new SequenceProfileData(data));
    }

    function getLessonStatus(scoId) {
        const learningData = getLearningData(scoId);
        if (learningData) {
            return learningData.getData().lessonStatus;
        }
        return "unknown";
    }

    function getLessonLocation(scoId) {
        const learningData = getLearningData(scoId);
        if (learningData) {
            return learningData.getData().lessonLocation;
        }
        return "";
    }

    // revealing public api
    return {

        getLearningData: getLearningData,
        setLearningData: setLearningData,

        /**
         * @deprecated
         * @param {String} scoId
         * @returns {Number}
         */
        getMasteryScore: function (scoId) {
            const learningData = getLearningData(scoId);
            if (learningData) {
                return learningData.getData().masteryScore;
            }
            return 80;
        },

        getScore: function (scoId) {
            const learningData = getLearningData(scoId);
            if (learningData) {
                return learningData.getData().score;
            }
            return 0;
        },

        getLessonStatus: getLessonStatus,
        getLessonLocation: getLessonLocation,

        // ToDo: Check with UI tests if necessary, return false when not.
        canResume: function (scoId) {

            const lessonStatus = getLessonStatus(scoId),
                lessonLocation = getLessonLocation(scoId);

            return (lessonLocation.length > 0) && (lessonStatus !== "na") && (lessonStatus !== "unknown");
        },

        setUsername: function (name) {
            username = name;
        },

        getUsername: function () {
            return username;
        }
    };
}
